/**
 * @generated SignedSource<<d0c60b28db37ccdf11087b6cfeab634e>>
 * @relayHash 6f54c89f4426971f079f05192902ea90
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6f54c89f4426971f079f05192902ea90

import { ConcreteRequest } from 'relay-runtime';
export type de_BetterDocRecommendationState = "ADMISSION_FAILED" | "ADMITTED" | "ADMITTING" | "MEDIC_CONFIRMED" | "MEDIC_SELECTED" | "NO_SERVICE" | "PENDING" | "RECOMMENDED" | "REJECTED" | "RESEARCHING" | "RESEARCH_FAILED" | "SERVICE_TRIAGE_FAILED" | "TRIAGING";
export type De_simulateBetterDocPatientSelectionInput = {
  medicMedhubId: number;
  sessionId: number;
};
export type useSimulateBetterDocPatientSelectionMutation$variables = {
  input: De_simulateBetterDocPatientSelectionInput;
};
export type useSimulateBetterDocPatientSelectionMutation$data = {
  readonly de_simulateBetterDocPatientSelection: {
    readonly actionResult: {
      readonly betterDocState: de_BetterDocRecommendationState | null;
      readonly caseId: string | null;
      readonly errorReason: string | null;
      readonly exchangeId: number | null;
      readonly httpStatusCode: number | null;
      readonly isSuccessful: boolean;
      readonly sessionId: number;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useSimulateBetterDocPatientSelectionMutation = {
  response: useSimulateBetterDocPatientSelectionMutation$data;
  variables: useSimulateBetterDocPatientSelectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": "actionResult",
  "args": null,
  "concreteType": "de_BetterDocSessionActionResult",
  "kind": "LinkedField",
  "name": "de_BetterDocSessionActionResult",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sessionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSuccessful",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "httpStatusCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "betterDocState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "caseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "exchangeId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSimulateBetterDocPatientSelectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_simulateBetterDocPatientSelectionPayload",
        "kind": "LinkedField",
        "name": "de_simulateBetterDocPatientSelection",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSimulateBetterDocPatientSelectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_simulateBetterDocPatientSelectionPayload",
        "kind": "LinkedField",
        "name": "de_simulateBetterDocPatientSelection",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "6f54c89f4426971f079f05192902ea90",
    "metadata": {},
    "name": "useSimulateBetterDocPatientSelectionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "57b5dba7779057dca589128356db1713";

export default node;
